import { Link } from "react-router-dom";
import { Music } from "lucide-react";

export default function Privacy() {
  return (
    <div className="min-h-screen bg-[#FAF7EE]" data-testid="privacy-page">
      <header className="bg-[#0B192C] text-[#FAF7EE] px-5 py-4">
        <Link to="/" className="inline-flex items-center gap-2" data-testid="back-to-home">
          <Music className="w-5 h-5 text-[#C69B3D]" aria-hidden />
          <span className="font-display font-bold text-lg">ChoirQuest</span>
        </Link>
      </header>
      <main className="max-w-3xl mx-auto px-5 py-10 space-y-12">
        <section>
          <h1 className="font-display text-3xl font-bold text-[#0B192C]">What does ChoirQuest remember?</h1>
          <div className="mt-4 rounded-2xl bg-white border border-[#E5DEC9] p-6 space-y-3 text-[#1C242B] leading-relaxed">
            <p>ChoirQuest remembers your username, your scores, the Notes you earn and how you're getting on with your music.</p>
            <p>We don't need your email address, phone number or where you live.</p>
            <p>Your choir teachers can see your learning progress so they can help you improve.</p>
            <p>There's no chat, no messaging and no public leaderboard — just you and your music.</p>
          </div>
        </section>

        <section>
          <h2 className="font-display text-2xl font-bold text-[#0B192C]">Privacy information for adults</h2>
          <div className="mt-4 rounded-2xl bg-white border border-[#E5DEC9] p-6 space-y-4 text-sm text-[#1C242B] leading-relaxed">
            <p><strong>Data held.</strong> For each chorister ChoirQuest stores a display name (chosen by the institution), a generated username, a hashed six-digit PIN, and learning records (answers, Notes, mastery, Quest progress). No child email addresses, phone numbers, dates of birth, photographs or home addresses are collected.</p>
            <p><strong>Data held for staff.</strong> Staff accounts hold name, email address and a hashed password for authentication.</p>
            <p><strong>Institutional responsibilities.</strong> Each institution is the data controller for its choristers' display names and is responsible for having appropriate authority to enrol children. ChoirQuest acts as data processor. <em>[Placeholder — formal legal review required.]</em></p>
            <p><strong>Access &amp; export.</strong> Institution administrators can export learning records (CSV) at any time and may request correction or deletion of records.</p>
            <p><strong>Retention &amp; deletion.</strong> Archived chorister profiles retain historic learning records until deletion is requested by the institution. Deletion removes the profile and associated personal identifiers in line with the platform's data-retention policy. <em>[Placeholder — retention schedule to be confirmed following legal review.]</em></p>
            <p><strong>No advertising.</strong> ChoirQuest carries no advertising, performs no behavioural profiling and never sells data.</p>
            <p><strong>Contact.</strong> For privacy questions, contact the platform operator. <em>[Placeholder — contact details to be confirmed.]</em></p>
          </div>
        </section>
      </main>
    </div>
  );
}
